import { Button } from "primereact/button";
import React, { Component, Fragment } from "react";
import CenterElement from "../../activity/activityComponent/CenterElement";
import DropItemUI from "../../ddTxtImg/ui/DropItemUI";
import ClassificationItemModel from "../model/ClassificationItemModel";
import ClassificationDropItemUI from "./ClassificationDropItemUI";
import DropItem from "../../ddTxtImg/model/DropItem";
import { Dialog } from "primereact/dialog";

class ClassificationContainerUI extends Component {
  componentDidMount = () => {
    window.x(this.txt);
  };
  render() {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    let { selectedStyle } = ClassificationContainerModel;
    let classificationItemList =
      ClassificationContainerModel.classificationItemList;
    let dropItemList = ClassificationContainerModel.dropItemList;

    let uiStyle = JSON.parse(JSON.stringify(selectedStyle));
    return (
      <Fragment>
        <div className="" style={{ marginTop: "10px" }}>
          <table className="table table-hover">
            <thead className="">
              <tr>
                {classificationItemList.map((item, index) => {
                  return (
                    <th
                      // className={uiStyle[0].class} style={uiStyle[0].style}
                      key={index}
                      scope="col"
                    >
                      <div className="p-grid">
                        <div className="p-col-1">
                          <a
                            href="#"
                            onClick={(e) => this.handleSwitchUpColumn(e, item)}
                          >
                            <i className="pi pi-chevron-left"></i>
                          </a>
                        </div>
                        <div className="p-col-1">
                          <a
                            href="#"
                            onClick={(e) =>
                              this.handleSwitchDownColumn(e, item)
                            }
                          >
                            <i className="pi pi-chevron-right"></i>
                          </a>
                        </div>
                        <div className="p-col-9">
                          <div
                            ref={(el) => (this.txt = el)}
                            dangerouslySetInnerHTML={{
                              __html: item.classificationItemName,
                            }}
                            contentEditable={true}
                            onBlur={(e) =>
                              this.handleClassificationItemChange(e, item)
                            }
                            onInput={(e) =>
                              this.handleClassificationItemChange(e, item)
                            }
                          ></div>
                        </div>
                        <div className="p-col-1">
                          {/* <Button onClick={(e)=>this.handleDeleteColumn} icon={"pi pi-trash"}></Button> */}
                          <a
                            href="#"
                            onClick={(e) => this.handleDeleteColumn(e, item)}
                            style={{ color: "red" }}
                          >
                            <i className="pi pi-trash"></i>
                          </a>
                        </div>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {dropItemList.map((lst, index) => {
                return (
                  <tr scope="row" key={index}>
                    {lst.map((dropitem, index1) => {
                      return (
                        <td
                          key={index1}
                          // className={uiStyle[0].class} style={uiStyle[0].style}
                        >
                          <ClassificationDropItemUI
                            activity={activity}
                            dropItem={dropitem}
                            quizViewer={quizViewer}
                          />
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* <Dialog header="Header" visible={this.state.displayBasic} style={{ width: '50vw' }} footer={this.renderFooter('displayBasic')} onHide={() => this.onHide('displayBasic')}>
          <p>Are you sure you want to delete this ?</p>
        </Dialog> */}
      </Fragment>
    );
  }
  handleAddColumn = () => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;

    ClassificationContainerModel.addClassificationItem();

    quizViewer.setState({});
  };

  handleAddRow = () => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.addKeyItem();

    quizViewer.setState({});
  };

  handleShowContextMenu = (e) => {
    e.preventDefault();
    let { v } = this.state;
    if (v == "hidden") v = "visible";
    else v = "hidden";

    this.setState({ v });
  };

  //   handleclassificationKeyChange = (e, classificationKey) => {
  //     //console.log(classificationKey.classificationkeyIndex)
  //     let { activity, quizViewer } = this.props;
  //     let { ClassificationContainerModel } = activity;
  //     let classificationKeyChanged = ClassificationContainerModel.classificationKeyList[classificationKey.classificationKeyIndex]
  //     classificationKeyChanged.classificationKeyName = e.target.textContent
  //     quizViewer.setState({});
  //   }

  handleClassificationItemChange = (e, classificationItem) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    let classificationitemChanged =
      ClassificationContainerModel.classificationItemList[
        classificationItem.classificationItemIndex
      ];
    classificationitemChanged.classificationItemName = e.target.textContent;
    quizViewer.setState({});
  };

  handleDeleteColumn = (e, classificationItem) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.deleteClassificationItem(classificationItem);
    quizViewer.setState({});
  };

  handleDeleteRow = (e, classificationKey) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.deleteClassificationKey(classificationKey);
    quizViewer.setState({});
  };
  handleSwitchUpRow = (e, classificationKey) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.switchUpKeys(classificationKey);

    //ClassificationContainerModel.deleteclassificationKey(classificationKey);
    quizViewer.setState({});
  };
  handleSwitchDownRow = (e, classificationKey) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.switchDownKeys(classificationKey);
    //ClassificationContainerModel.deleteclassificationKey(classificationKey);
    quizViewer.setState({});
  };

  handleSwitchUpColumn = (e, classificationItem) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.switchUpItem(classificationItem);

    quizViewer.setState({});
  };

  handleSwitchDownColumn = (e, classificationItem) => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.switchDownItem(classificationItem);

    quizViewer.setState({});
  };

  handlePrevStyle = () => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.prevStyle();

    quizViewer.setState({});
  };
  handleNextStyle = () => {
    let { activity, quizViewer } = this.props;
    let { ClassificationContainerModel } = activity;
    ClassificationContainerModel.nextStyle();

    quizViewer.setState({});
  };
}
export default ClassificationContainerUI;
